import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { fetchProfilesByUser, updateProfile } from "../api/index";

const SeatlessContext = createContext({
  seatlessMode: false,
  setSeatlessMode: () => {},
  profileId: null,
  loading: true,
  toggleLocked: false,
  setToggleLocked: () => {},
});

export const SeatlessProvider = ({ children }) => {
  const [seatlessMode, setSeatlessModeState] = useState(false);
  const [profileId, setProfileId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toggleLocked, setToggleLocked] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("profile"));
        const userId = user?.result?._id || user?.result?.googleId;
        if (!userId) return setLoading(false);
        const res = await fetchProfilesByUser({ search: userId });
        const prof = res?.data?.data;
        if (prof?._id) setProfileId(prof._id);
        setSeatlessModeState(!!prof?.seatlessTicketMode);
      } catch (e) {
        // ignore
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const setSeatlessMode = useCallback(async (enabled) => {
    setSeatlessModeState(enabled);
    try {
      if (profileId) {
        await updateProfile(profileId, { seatlessTicketMode: !!enabled });
      }
    } catch (e) {
      // ignore
    }
  }, [profileId]);

  const value = useMemo(
    () => ({ seatlessMode, setSeatlessMode, profileId, loading, toggleLocked, setToggleLocked }),
    [seatlessMode, setSeatlessMode, profileId, loading, toggleLocked, setToggleLocked]
  );

  return (
    <SeatlessContext.Provider value={value}>{children}</SeatlessContext.Provider>
  );
};

export const useSeatless = () => useContext(SeatlessContext);

export default SeatlessContext;


